var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width :_vm.width+'px'})},[(_vm.showLabel)?_c('div',[(_vm.utils.string.vNotEmpty(_vm.label))?_c('div',[_c('line-overflow',{attrs:{"content":_vm.label,"max-lines":1}})],1):_c('div',[_c('br')])]):_vm._e(),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }